<template>
    <div class="tips-area text-center">
        <div class="tips-area__icon">
            <i class="el-icon-check"></i>
        </div>
        <div class="tips-area__msg">
            批量导入成功
        </div>
        <div class="tips-area__footer">
            <el-button @click="goPage('/index/member')" type="primary">查看人员列表</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step3',
    inject: ['back', 'goPage', 'tel']
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    .tips-area {
        margin-top: 114px;
        .tips-area__icon {
            display: inline-block;
            border-radius: 50%;
            color: #fff;
            line-height: 108px;
            font-size: 48px;
            width: 100px;
            height: 100px;
            background-color: $--color-primary;
        }
        .tips-area__msg {
            margin-top: 28px;
            margin-bottom: 56px;
        }
        .tips-area__footer {

        }
    }
</style>
